module.exports = __webpack_public_path__ + "static/media/icon_medal.fb60b412.svg";